import { render, staticRenderFns } from "./SalesTicketsView.vue?vue&type=template&id=24160bea"
import script from "./SalesTicketsView.vue?vue&type=script&lang=js"
export * from "./SalesTicketsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports